<template>
	<div>
		<el-dialog title="服务详情" :visible.sync="show" width="500px">
			<jzdep :row="row"></jzdep>
			<el-divider></el-divider>
			<div v-if="row.status!='审核中'">
				<h3 style="margin-bottom: 10px;">客服处理</h3>
				<div>处理人 ：{{row.approvalName}}</div>
				<div style="margin:  10px 0;">处理时间 ：{{setTime(row.approvalTime)}}</div>
				<div>处理状态 ：{{row.status}}</div>
				<div style="margin:  10px 0;" v-if="row.result=='已确认'||row.result=='已完成'||row.result=='已支付'||row.result=='已填写'">
	
				</div>
	
				<div v-if="row.result=='已完成'||row.result=='已完善'" style="margin-top:30px">
					<h3 style="margin-bottom: 10px;">服务</h3>
					<div>服务人姓名 ：{{row.worker}}</div>
					<div style="margin:  10px 0;">服务人手机号 :{{row.workerPhone}}</div>
				</div>
				<div v-if="row.result=='已完成'">
					<div>完成状态 ：{{row.result}}</div>
					<div style="margin:  10px 0;">完成时间 ：{{setTime(row.completeTime)}}</div>
				</div>
			</div>
		</el-dialog>

		<el-dialog title="派单" :visible.sync="showPai" width="500px">
			<jzdep :row="row"></jzdep>
			<el-divider></el-divider>
        <span>保洁人员：</span>
				<el-select filterable v-model="bjUserId" placeholder="请选择保洁人员">
					<el-option  v-for=" item in BJList" :label="item.userName" :value="item.userId"></el-option>
					<el-option label="未来访" value="未来访"></el-option>
				</el-select>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showPai = false">取 消</el-button>
				<el-button type="primary" @click="paiClick">确 定</el-button>
			</span>
		</el-dialog>
	
		<el-dialog title="审核" :visible.sync="show2" width="500px">
			<div>
				<span>审批意见：</span>
				<el-input type="textarea" v-model="formData.reason" label="同意入住"></el-input>
			</div>
			<div style="margin-top: 10px;">
				<span style="margin-right: 10px;">审批结果：</span>
				<el-radio v-model="formData.status" label="pass">同意</el-radio>
				<el-radio v-model="formData.status" label="reject">驳回</el-radio>
			</div>
			<span slot="footer" class="dialog-footer">
						<el-button type="primary" @click="submitAgree">审核</el-button>
					</span>
		</el-dialog>
		<el-form :inline="true" :model="form" class="demo-form-inline">
			<el-form-item label="申请人">
				<el-input v-model="form.username" placeholder="申请人" clearable=""></el-input>
			</el-form-item>
			<el-form-item label="处理状态">
				<el-select v-model="form.status" placeholder="处理状态" clearable="clearable">
					<el-option label="已同意" value="已同意"></el-option>
					<el-option label="已拒绝" value="已拒绝"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="getAll()">查询</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="data" style="width: 100%" border :key="tableKey">
			<el-table-column type="index" label="序号" width="60"></el-table-column>
			<el-table-column prop="username" label="申请人"></el-table-column>
			<el-table-column prop="phone" label="联系电话"></el-table-column>
			<el-table-column prop="projectName" label="服务项目"></el-table-column>
			<el-table-column prop="price" label="服务价格(元)"></el-table-column>
			<el-table-column prop="createTime" label="申请时间">
				<template slot-scope="{row}">{{setTime(row.createTime)}}
				</template>
			</el-table-column>
			<el-table-column prop="leaveMessage" label="备注"></el-table-column>
			<el-table-column prop="status" label="处理状态"></el-table-column>
			<el-table-column prop="date" label="操作">
				<template slot-scope="{row}">
					<el-button type="text" @click="getRow(row)">
						查看</el-button>
					<span style="margin-left:10px;" v-if="row.status=='审核中'">
						<el-button v-hasPermi="['apply:serve:end']"  type="text" @click="editRow(row)">
						审核</el-button>
					</span>
					<span style="margin-left:10px;" v-if="row.status=='已同意'&&row.result=='已处理'">
						<el-button v-hasPermi="['apply:serve:end']"  type="text" @click="paiRow(row)">
						派单</el-button>
					</span>
					<span style="margin-left:10px;" v-if="row.status=='已同意'&&row.result=='已完善'">
						<el-button v-hasPermi="['apply:serve:end']"  type="text" @click="successRow(row)">
						完成</el-button>
					</span>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper"
			:total="totalNum">
		</el-pagination>
	</div>
</template>

<script>
import jzdep from "./jzdep.vue";
export default {
  components: {
    jzdep,
  },
  data() {
    return {
      bjUserId: "",
      BJList: [],
      showPai: false,
      tableKey: 1,
      formData: {
        reason: "",
        status: "pass",
      },
      roleId: sessionStorage.roleId,
      user: "", //派单选择的工人
      users: [],
      show: false,
      show2: false,
      data: [],
      reason: null,
      row: {},
      form: {
        result: "未完成",
        status: "", //
        username: "",
        currentPage: 1,
        pageSize: 10,
        type: "家政",
      },
      totalNum: 0,
    };
  },
  methods: {
    getBJ() {
      this.$http.get(`/api/bdServiceApply/queryBj`).then((res) => {
        this.BJList = res.data.data;
      });
      // /bdServiceApply/queryBj
    },
    submitAgree() {
      if (this.formData.reason == "") {
        this.$message.error("请输入审核意见");
        return;
      }
      this.$http
        .post(`/api/bdServiceApply/ApprovalServiceApply`, {
          id: this.row.id,
          status: this.formData.status,
          reason: this.formData.reason,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.show2 = false;
            this.$message.success(res.data.message);
            this.getAll();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    getId(val) {
      console.log(val);
    },
    yes() {
      console.log(this.user);
      if (this.user == "") {
        this.$message.warning("请选择保洁");
        return;
      }
      this.show = false;
      this.$http
        .post(`/api/bdServiceApply/dispatch`, {
          dispatch: this.user,
          processId: this.row.processId,
          id: this.row.id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success(res.data.message);
            this.getAll();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    ok(type) {
      this.show = false;
      this.$http
        .post(`/api/bdServiceApply/ApprovalServiceApply`, {
          id: this.row.id,
          result: type ? "已同意" : "已拒绝",
          processId: this.row.processId,
          agree: type == 1,
          reason: this.reason,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success(res.data.message);
            this.getAll();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    handleCurrentChange(val) {
      this.form.currentPage = val;
      this.getAll();
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.getAll();
    },
    getRow(row) {
      console.log(row);
      // row.showPathList=JSON.parse(row.showPathList)
      this.row = row;
      this.show = true;
    },
    paiRow(row) {
      this.getBJ();
      this.row = row;
      this.bjUserId = "";

      //   this.$http.get(`/api/bdServiceApply/selectOne?id=${row.id}`).then((res) => {
      //     console.log(res);
      this.showPai = true;
      //   });
    },
    successRow(row) {
      this.$confirm("是否确认该服务已完成?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/api/bdServiceApply/confirmComplete", {
              id: row.id,
              processId:row.processId,
            })
            .then((res) => {
              if (res.data.code == "0") {
                this.$message.success(res.data.message);
				this.getAll();
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
      return;
    },
    paiClick() {
      console.log(this.row);
      if (this.bjUserId == "") {
        this.$message.warning("请选择保洁");
        return;
      }
      //list获取指定选中值的对象
      let BJUser = this.BJList.filter((item) => {
        return item.userId == this.bjUserId;
      })[0];
      this.$http
        .post("/api/bdServiceApply/writeWorker", {
          worker: BJUser.userName + "",
          workerPhone: BJUser.phonenumber + "",
          id: this.row.id,
          processId: this.row.processId,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.showPai = false;
			this.getAll();
            this.$message.success("派工完成");
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    editRow(row) {
      this.row = row;
      this.show2 = true;
    },
    getAll() {
      this.$http
        .post(`/api/bdServiceApply/queryWebServiceApply`, this.form)
        .then((r) => {
          if (r.data.data != null) {
            this.tableKey += 1;
            this.data = r.data.data.items;
            this.totalNum = r.data.data.totalNum;
          } else {
            this.data = null;
            this.totalNum = 0;
          }
        });
    },
    getUsers() {
      this.$http.get(`/api/bdServiceApply/getDispatch`).then((r) => {
        this.users = r.data.data;
      });
    },
  },
  mounted() {
    this.getAll();
    this.getUsers();
  },
};
</script>

<style>
</style>
